"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathListener = void 0;
var set_1 = __importDefault(require("lodash/set"));
var updateListeners_1 = require("./updateListeners");
// TODO: This needs to be rethought around the get operation
// that is the only one that responds to updates to the state
// and creates a dependency chain between args + once one arg
// is updated the rest need to be updated to the latest version
// from the state which could trigger the evaluation for other
// statements as well
var pathListener = function (_this, update, db, data, structure, node) {
    // Don't trigger is for updates that occur during anoter get
    // operation that would otherwise call the update multiple
    // times for the same value
    return function (newValue, patch, shouldUpdate) {
        if (newValue === node.value) {
            return;
        }
        node.value = newValue;
        node.fromPatch = patch;
        (0, set_1.default)(_this.data, node.nesting, node.value);
        (0, updateListeners_1.updateListeners)(_this, update, db, _this.data, structure, node);
        if (!shouldUpdate) {
            update();
        }
    };
};
exports.pathListener = pathListener;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aExpc3RlbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBoL3BhdGhMaXN0ZW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxtREFBNkI7QUFTN0IscURBQW9EO0FBR3BELDREQUE0RDtBQUM1RCw2REFBNkQ7QUFDN0QsNkRBQTZEO0FBQzdELCtEQUErRDtBQUMvRCw4REFBOEQ7QUFDOUQscUJBQXFCO0FBQ2QsSUFBTSxZQUFZLEdBQUcsVUFDMUIsS0FBWSxFQUNaLE1BQWdCLEVBQ2hCLEVBQXFCLEVBQ3JCLElBQWUsRUFDZixTQUF5QixFQUN6QixJQUFlO0lBRWYsNERBQTREO0lBQzVELDBEQUEwRDtJQUMxRCwyQkFBMkI7SUFDM0IsT0FBTyxVQUFDLFFBQWEsRUFBRSxLQUFlLEVBQUUsWUFBc0I7UUFDNUQsSUFBSSxRQUFRLEtBQUssSUFBSSxDQUFDLEtBQUssRUFBRTtZQUMzQixPQUFPO1NBQ1I7UUFDRCxJQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQztRQUN0QixJQUFJLENBQUMsU0FBUyxHQUFHLEtBQUssQ0FBQztRQUN2QixJQUFBLGFBQUcsRUFBQyxLQUFLLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBRTFDLElBQUEsaUNBQWUsRUFBQyxLQUFLLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBRSxLQUFLLENBQUMsSUFBSSxFQUFFLFNBQVMsRUFBRSxJQUFJLENBQUMsQ0FBQztRQUVoRSxJQUFJLENBQUMsWUFBWSxFQUFFO1lBQ2pCLE1BQU0sRUFBRSxDQUFDO1NBQ1Y7SUFDSCxDQUFDLENBQUM7QUFDSixDQUFDLENBQUM7QUF6QlcsUUFBQSxZQUFZLGdCQXlCdkIifQ==